// src/components/Careers/CareersHero/CareersHero.js
import React from 'react';
import './CareersHero.css'; // Updated import

// Renamed function from Hero to CareersHero
function CareersHero() {
  return (
    // Updated className for better specificity
    <section className="careers-hero-section">
      <div className="careers-hero-image-container">
        <picture>
          <source
            media="(min-width: 768px)"
            srcSet="https://sendbird.imgix.net/cms/career-hero-round_2023-03-02-234228_zrcx.jpg?auto=format,compress&amp;crop=faces"
          />
          <img
            src="https://sendbird.imgix.net/cms/career-hero-mobile_2023-03-02-234329_cdag.jpg?auto=format,compress&amp;crop=faces"
            alt="A diverse group of Sendbird team members"
            className="careers-hero-image"
          />
        </picture>
      </div>
    </section>
  );
}

// Updated export
export default CareersHero;